<template>
    <div id="search">
        <input
            id="pac-input"
            v-model="search"
            class="controls"
            type="text"
            autocomplete="off"
            placeholder="Vyhľadávanie bodu ..."
            @input="onChange"
            @keydown.down="onArrowDown"
            @keydown.up="onArrowUp"
            @keydown.enter="onEnter"
        />

        <div class="autocomplete-results" v-if="isOpen">
            <ul class="list-group list-group-flush" id="results">
                <li
                    class="list-group-item"
                    v-for="(result, i) in results"
                    :key="i"
                    @click="setResult(result)"
                    :class="{ active: i === arrowCounter }"
                >
                    {{ result.name }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { bus } from "../../main";

export default {
    name: "Autocomplete",
    props: {
        markers: Array
    },

    data() {
        return {
            search: "",
            results: [],
            isOpen: false,
            arrowCounter: 0
        };
    },

    methods: {
        onChange() {
            this.results = this.markers.filter(marker => {
                this.isOpen = true;
                return marker.name
                    .replace("/", "")
                    .startsWith(this.search.replace("/", ""));
            });

            if (this.search == "") {
                this.$emit("input", "");
            }
        },

        setResult(result) {
            this.search = result.name;
            this.$emit("input", this.search);
            this.isOpen = false;
        },

        reset: function() {
            this.search = "";
            this.isOpen = false;
        },

        onArrowDown() {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },

        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },

        onEnter() {
            this.search = this.results[this.arrowCounter]
                ? this.results[this.arrowCounter].name
                : "";
            this.$emit("input", this.search);
            this.isOpen = false;
            // this.arrowCounter = -1;
        },

        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                this.isOpen = false;
                // this.arrowCounter = -1;
            }
        }
    },

    mounted() {
        bus.$on("resetSearch", this.reset);
        document.addEventListener("click", this.handleClickOutside);
    },
    destroyed() {
        document.removeEventListener("click", this.handleClickOutside);
    }
};
</script>

<style scoped>
html,
body,
#map-canvas {
    height: 100%;
    margin: 0px;
    padding: 0px;
}

.controls {
    border: 1px solid transparent;
    border-radius: 2px 0 0 2px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    height: 40px;
    outline: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

#search {
    /*position: absolute;*/
    /*top: 0;*/
    /*left: 50%;*/
}

#pac-input,
.autocomplete-results {
    background-color: #fff;
    font-size: 15px;
    font-weight: 300;
    padding: 0 11px 0 13px;
    text-overflow: ellipsis;
    max-width: 400px;
    width: 100%;
    /*position: relative;*/
    /*left: -50%;*/
    z-index: 999;
}

.autocomplete-results {
    padding: 0;
    border: 1px solid #eeeeee;
    height: 220px;
    overflow: auto;
    width: 100%;
    margin: 0 auto;
}

.autocomplete-results ul {
    text-align: left;
}

#pac-input:focus {
    border-color: #4d90fe;
}

.pac-container {
    font-family: Roboto;
}

#type-selector {
    color: #fff;
    background-color: #4d90fe;
    padding: 5px 11px 0px 11px;
}

#type-selector label {
    font-family: Roboto;
    font-size: 13px;
    font-weight: 300;
}

.is-active {
    background: red;
}
</style>
